import { render } from "./blogCard.vue?vue&type=template&id=59b248bf"
import script from "./blogCard.vue?vue&type=script&lang=js"
export * from "./blogCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__